/**
 * @generated SignedSource<<dcdf32a019dac34f1918d281e727db6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductMultipleVariantsRuleInput = {
  attributeCodes: ReadonlyArray<string>;
  bulkAsNameAndNumberEnabled: boolean;
  enableImportCSV: boolean;
  nameAndNumberEnabled: boolean;
  options?: string | null;
  skipOptionForNameAndNumber: boolean;
};
export type bulkVariationEditor_UpdateMutation$variables = {
  id: string;
  input: ProductMultipleVariantsRuleInput;
};
export type bulkVariationEditor_UpdateMutation$data = {
  readonly updateProductMultipleVariantsRule: {
    readonly attributeCodes: ReadonlyArray<string>;
    readonly bulkAsNameAndNumberEnabled: boolean;
    readonly enableImportCSV: boolean;
    readonly nameAndNumberEnabled: boolean;
    readonly options: string | null;
    readonly skipOptionForNameAndNumber: boolean;
  };
};
export type bulkVariationEditor_UpdateMutation = {
  response: bulkVariationEditor_UpdateMutation$data;
  variables: bulkVariationEditor_UpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "productId",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductMultipleVariantsRule",
    "kind": "LinkedField",
    "name": "updateProductMultipleVariantsRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "attributeCodes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameAndNumberEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skipOptionForNameAndNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bulkAsNameAndNumberEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableImportCSV",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "options",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkVariationEditor_UpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkVariationEditor_UpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d01176382802bfd9c908a41035c0502",
    "id": null,
    "metadata": {},
    "name": "bulkVariationEditor_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation bulkVariationEditor_UpdateMutation(\n  $id: ID!\n  $input: ProductMultipleVariantsRuleInput!\n) {\n  updateProductMultipleVariantsRule(productId: $id, input: $input) {\n    attributeCodes\n    nameAndNumberEnabled\n    skipOptionForNameAndNumber\n    bulkAsNameAndNumberEnabled\n    enableImportCSV\n    options\n  }\n}\n"
  }
};
})();

(node as any).hash = "55e3c79e8f3451ce7d15b4ccfc4bffcf";

export default node;
